import React from "react";
import { AdminAuthFormProps } from "../types";
import "../EmployeesPage.css";
import { Button } from "../../../ds2/components";

export const AdminAuthForm: React.FC<AdminAuthFormProps> = ({
  adminSecret,
  verifying,
  error,
  onSecretChange,
  onSubmit,
}) => {
  return (
    <div className="employees-page">
      <div className="employees-page-header">
        <h1>Admin Access Required</h1>
      </div>
      <div className="employees-page-content">
        <form onSubmit={onSubmit} className="admin-auth-form">
          <div className="admin-auth-field">
            <label htmlFor="adminSecret">Admin Secret:</label>
            <input
              type="password"
              id="adminSecret"
              value={adminSecret}
              onChange={(e) => onSecretChange(e.target.value)}
              placeholder="Enter admin secret"
              required
            />
          </div>
          <Button
            type="submit"
            variant="primary"
            disabled={verifying}>
            {verifying ? "Verifying..." : "Access Admin Panel"}
          </Button>
          
          {/* <button type="submit" disabled={verifying}>
            {verifying ? "Verifying..." : "Access Admin Panel"}
          </button> */}
        </form>
        {error && <div className="employees-page-error">{error}</div>}
      </div>
    </div>
  );
};